export default __webpack_public_path__ + "static/media/pj-ifood-rn.909c21fb.png";